import React from 'react';
import { Input, FormField } from 'semantic-ui-react';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import Field from './Field';

const handleDateChange = (onChange, name) => date =>
  onChange(null, {
    name,
    value: moment(date).isValid()
      ? date.format('YYYY-MM-DD')
      : null
  });

const DateInput = ({ disabled, date, onChange, text, name }) => (
  <Field>
    <FormField
      className="c-DatePicker__wrapper c-DatePicker__wrapper--filters"
      disabled={disabled}
    >
      <label>{text} Date</label>
      <DatePicker
        dateFormat="DD/MM/YYYY"
        selected={date && moment.utc(date, 'YYYY-MM-DD')}
        onChange={handleDateChange(onChange, name)}
        isClearable
        showMonthDropdown
        showYearDropdown
        customInput={<Input style={{ width: '100%' }} />}
        placeholderText={`${text} Date`}
        onChangeRaw={event => event.preventDefault()}
      />
    </FormField>
  </Field>
);

export default DateInput;



// WEBPACK FOOTER //
// ./src/component/DateInput.js